<div class="main-footer">
  <div class="main-footer-collapse">
    <cw-action-icon
      icon="menu-open"
      font="cortex"
      [size]="24"
      [ariaLabel]="i18n.t('navigation.toggle')"
      [class.collapsed]="isSidebarCollapsed()"
      (activeChange)="toggleSidebar()"
    ></cw-action-icon>
  </div>

  <div class="main-footer-status">
    <div class="main-footer-clock">
      <span>{{ weekday() }}</span>
      <span class="main-footer-divider"></span>
      <span>{{ date() }}</span>
      <span class="main-footer-divider"></span>
      <span>{{ time() }}</span>
    </div>

    <div class="main-footer-pill main-footer-pill--conflicts">
      {{ i18n.t('footer.stockConflicts', { count: stockConflictCount() }) }}
    </div>
  </div>

  <div class="main-footer-device">
    <div class="main-footer-pill">
      <cw-icon icon="computer" size="sm"></cw-icon>
      <span>{{ workstationName() }}</span>
    </div>
  </div>
</div>
